'use strict';

const Mn = require('backbone.marionette');
const Moment = require('moment');
const Tooltip = require('common/ui/view/behavior/tooltip');
const MyProjectStatusRepository = require('balus/domain/repository/my/project-status');
const ReadMore = require('common/ui/view/behavior/readmore');
const ProjectItemViewTemplate = require('balus/ui/template/body/user/content/project-item.hbs');
const NoProjectTemplate = require('balus/ui/template/body/user/content/no-project.hbs');

const ProjectItemView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item',
    template: ProjectItemViewTemplate,
    behaviors: [Tooltip],

    templateContext: function() {
        const totalActionCount = this.model.getActionTotalActionCount();
        const initialActionCount = this.model.getActionInitialStateCount();
        const normalActionCount = this.model.getActionNormalStateCount();
        const finalActionCount = this.model.getActionFinalStateCount();
        let initialWidth = initialActionCount / totalActionCount * 100;
        let normalWidth = normalActionCount / totalActionCount * 100;
        let finalWidth = finalActionCount / totalActionCount * 100;

        const context = this.getOption('context');
        const user = context.getUser();
        const today = Moment();
        const endAt = this.model.getEndAt();
        const lastDays = Moment(endAt).diff(today, 'days');
        const delayedDays = -lastDays;
        const isDelayed = lastDays < 0;
        const hasDelayedActions = this.model.hasDelayedActions();

        // ダミーのデータを用意
        const commentsNum = 42;
        const tasksNum = 11;
        const hasNewTask = true;
        const myActionsNum = 5;
        const pastDueActionsNum = 2;

        const members = this.buildProjectMembersList();

        return {
            imageURL: this.model.getImageURL(),
            name: this.model.getName(),
            link: this.model.path(),
            groupURL: this.model.getGroupURL(),
            stateType: this.model.getStateType(),
            totalActionCount: totalActionCount,
            initialActionCount: initialActionCount,
            normalActionCount: normalActionCount,
            finalActionCount: finalActionCount,
            initialWidth: initialWidth,
            normalWidth: normalWidth,
            finalWidth: finalWidth,
            userImageURL: user.getImageURL(),
            lastDays: lastDays,
            delayedDays: delayedDays,
            isDelayed: isDelayed,
            hasDelayedActions: hasDelayedActions,
            hasWarning: isDelayed || hasDelayedActions,
            commentsNum: commentsNum,
            tasksNum: tasksNum,
            hasNewTask: hasNewTask,
            members: members,
            myActionsNum: myActionsNum,
            pastDueActionsNum: pastDueActionsNum
        };
    },

    buildProjectMembersList: function() {
        const user = this.getOption('context').getUser();
        const members = this.model.getMembers().clone();

        // ログイン中ユーザがメンバーになっている場合には、先頭に追加しなおす
        const currentUserMember = members.getMemberByUser(user.id);
        if (currentUserMember) {
            members.remove(currentUserMember);
            members.add(currentUserMember, {at: 0});
        }

        return _.map(members.models, member => {
            return member.attributes;
        });
    },

    onRender: function() {
        this.$('.my-projects-action-progress-bar.hidden').remove();
    }
});

const NoProjectView = Mn.View.extend({
    template: NoProjectTemplate
});

module.exports = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'list list-bordered',
    emptyView: NoProjectView,
    childView: ProjectItemView,
    childViewOptions: function() {
        return {
            context: this.getOption('context')
        }
    },
    behaviors: {
        ReadMore: {
            behaviorClass: ReadMore,
            showReadMore: function() {
                return MyProjectStatusRepository.find().hasNext();
            },
            onReadMore: function() {
                MyProjectStatusRepository.find().fetchNext(10);
            }
        }
    }
});




// WEBPACK FOOTER //
// ./balus/ui/view/body/user/content/project-status-list.js